import React from "react";
import { SimpleTextInputCard } from "sortation/components/SimpleTextInputCard";
import { useTransferScan } from "./useTransferScan";

export const TransferScan = () => {
  const { barcode, isLoading, setBarcode, handleTransferScan } = useTransferScan();

  return (
    <SimpleTextInputCard
      title="Scan Gaylord Barcode"
      label="Gaylord ID"
      value={barcode}
      onSubmit={handleTransferScan}
      onChange={setBarcode}
      disabled={isLoading}
      debounceSubsequent
    />
  );
};
